import useCurrentMerchant from 'hooks/useCurrentMerchant'
import Cookie from 'js-cookie'
import { useEffect, useState } from 'react'

export default function useLegalDocsNagDismissal(): [boolean, () => void] {
  const merchant = useCurrentMerchant()
  const cookieName = merchant?.id
    ? `legal_docs_nag_dismissed_${merchant.id}`
    : null

  const [isDismissed, setIsDismissed] = useState(() =>
    cookieName ? Cookie.get(cookieName) === 'true' : false
  )

  useEffect(() => {
    if (!cookieName) {
      setIsDismissed(false)
      return
    }
    setIsDismissed(Cookie.get(cookieName) === 'true')
  }, [cookieName])

  const dismiss = () => {
    if (!cookieName) return
    // SameSite intentionally omitted — matches auth cookie pattern;
    // modern browsers default to Lax.
    Cookie.set(cookieName, 'true', {
      expires: new Date(Date.now() + 3600000),
      path: '/',
      secure:
        process.env.NODE_ENV !== 'development' &&
        process.env.NODE_ENV !== 'test',
    })
    setIsDismissed(true)
  }

  return [isDismissed, dismiss]
}
